export default __webpack_public_path__ + "static/media/whatsview-example.eec99241.zip";